<template>
    <div class="container text-center">
        <span class="font-xs text-secondary">
            Home Credit is a fast, secure way to shop from the safety of your home.
        </span>
        <br />
        <!-- <span :id="learnMoreId" @click="openSite" class="font-sm text-success clickable">Learn more</span> -->
    </div>
</template>
<script>
export default {
    props: ['learnMoreId'],
    methods: {
        openSite() {
            window.location.href = "https://homecredit.ph/hcpay/";
        }
    }
}
</script>